// extracted by mini-css-extract-plugin
module.exports = {"dropArea":"FileDrop_dropArea_2hg5k","dropAreaDragging":"FileDrop_dropAreaDragging_3D2jx"};